import { gsap } from '../rk-gsap-core'

// Thank You Page Animations
export default function initializeThankYouAnimations() {
  const fadeInElements = document.querySelectorAll('.rocklin-logo, .thank-you-message, .streetside-logo')

  gsap.from(fadeInElements, {
    opacity: 0,
    duration: 2,
    ease: 'power2.out',
    stagger: 0.25,
    delay: 0.5
  })
}